import classnames from 'classnames';

import './ItineraryFeatureCard.scss';

type Props = {
  /** Alt text for image */
  alt?: string;
  /** Center text horizontally */
  centerText?: boolean;
  children: React.ReactNode;
  /** Optional CSS class */
  className?: string;
  /** Place image on the left or the right of the text */
  imageAlign?: null | 'left' | 'right';
  /** Make image smaller on mobile viewport */
  imageSmall?: boolean;
  imgUrl?: string;
};

const ItineraryFeatureCard = ({
  alt = '',
  centerText,
  children,
  className,
  imageAlign = 'left',
  imageSmall,
  imgUrl,
}: Props) => {
  const cssClasses = classnames({
    '-centerText': centerText,
    '-imageRight': imageAlign === 'right',
    '-imageSmall': imageSmall,
    [className]: className,
    ItineraryFeatureCard: true,
  });

  return (
    <div className={cssClasses}>
      <div className="ItineraryFeatureCard__image">
        <div className="ItineraryFeatureCard__image-inner">{imgUrl && <img alt={alt} aria-hidden src={imgUrl} />}</div>
      </div>
      <div className="ItineraryFeatureCard__body">{children}</div>
    </div>
  );
};

export default ItineraryFeatureCard;
